import { Node, useReactFlow } from 'reactflow';
import { makeNodeUnconnectedToHwId } from '../components/Flow/NodeTypeSelect';
import { useCallback } from 'react';
import { DeleteSource } from '../types';

const useDeleteNode = () => {
    const { setNodes, setEdges, getEdges, getNodes, deleteElements } = useReactFlow();

    const removeUnusedZonesAndEdges = useCallback(
        (node: Node) => {
            const nodes = getNodes();
            const edges = getEdges();
            const fn = makeNodeUnconnectedToHwId(node.data.hw_id);
            const newEdges = edges.filter((edge) => edge.source !== node.id);
            const newNodes = nodes
                .map(fn)
                .filter(
                    (node) =>
                        node.connectedHwIds === undefined ||
                        node.connectedHwIds.length > 0 ||
                        newEdges.some((edge) => edge.target === node.id),
                );
            setNodes(newNodes);
            setEdges(newEdges);
        },
        [getEdges, getNodes, setEdges, setNodes],
    );

    const handleDeleteNode = useCallback(
        (node: Node, deleteSource: DeleteSource | undefined = 'button') => {
            if (node.deletable === false) return;

            if (node.data.hw_id) {
                removeUnusedZonesAndEdges(node);
            }
            if (deleteSource === 'button') {
                deleteElements({ nodes: [{ id: node.id }] });
            }
        },
        [deleteElements, removeUnusedZonesAndEdges],
    );

    return { handleDeleteNode, removeUnusedZonesAndEdges };
};

export default useDeleteNode;
